import IAuthentication from '../models/IAuthentication';
import BaseApi from './baseApi';

export default class PrintingApi extends BaseApi {
    companyId : string = "";

    constructor(formName: string) {
        super("Repport", formName);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
    }

    async Print(idRepport : string, idName: string, idValue: string[], format : string) : Promise<string> {
        let json : string = this.getJsonRead(idRepport, idName, idValue, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintCustomerStock(idRepport : string, idCustomer: string[], warehouseNames: string[], bestBeforeDates: string[], inboundCodes: string[], goodNames: string[], format: string) {
        let json : string = this.getJsonReadCustomerStock(idRepport, idCustomer, warehouseNames, bestBeforeDates, inboundCodes, goodNames, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintMaandaangifte(idRepport: string, dateIn: string, format: string): Promise<string> {
        let json: string = this.getJsonReadMaandaangifte(idRepport, dateIn, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";

        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockWithFilters(idRepport: string, idWarehouses: string[], dateIn: string[], bestBeforeDate: string[], locationName: string[], palletTypeName: string[], customerName: string[], inboundCode: string[], inboundCodeDestination: string[], goodName: string[], companySourceName: string[], format : string) : Promise<string> {
        let json : string = this.getJsonReadStock(idRepport, idWarehouses, dateIn, bestBeforeDate, locationName, palletTypeName, customerName, inboundCode, inboundCodeDestination, goodName, companySourceName, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockGroupedWithFilters(idRepport: string, idWarehouses: string[], dateIn: string[], bestBeforeDate: string[], locationName: string[], customerName: string[], inboundCode: string[], inboundCodeDestination: string[], goodName: string[], companySourceName: string[], format : string) : Promise<string> {
        let json : string = this.getJsonReadStockGrouped(idRepport, idWarehouses, dateIn, bestBeforeDate, locationName, customerName, inboundCode, inboundCodeDestination, goodName, companySourceName, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockMovement(idRepport : string, idWarehouses: string[], idCompany: string, idsCustomers: string[], date: string, format : string) : Promise<string> {
        let json : string = this.getJsonReadStockMovement(idRepport, idWarehouses, idCompany, idsCustomers, date, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockMovementDates(idRepport : string, idWarehouses: string[], idCompany: string, dateStockIni: string, dateStockEnd: string, format : string) : Promise<string> {
        let json : string = this.getJsonReadStockMovementDates(idRepport, idWarehouses, idCompany, dateStockIni, dateStockEnd, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockMovementBillingDates(idRepport : string, idCustomer : string, dateStockIni: string, dateStockEnd: string, format : string) : Promise<string> {
        let json : string = this.getJsonReadStockMovementBillingDates(idRepport, idCustomer, dateStockIni, dateStockEnd, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintStockMovementCompanyAndDates(idRepport : string, idCompanySource : string, dateStockIni: string, dateStockEnd: string, format : string) : Promise<string> {
        let json : string = this.getJsonReadStockMovementCompanyAndDates(idRepport, idCompanySource, dateStockIni, dateStockEnd, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintLabels(idRepport : string, idName: string, idValue: string[], format : string) : Promise<string> {
        let json : string = this.getJsonReadLabels(idRepport, idName, idValue, format);
        const response = await this.api.post('GetMultiRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async PrintInboundOutboundSellReport(idRepport: string, idCustomer: string, initialDateReport: string, endDateReport: string, withInbound: boolean, withOutbound: boolean, withSell: boolean, format: string) {
        let json : string = this.getJsonReadInboundOutboundSellReport(idRepport, idCustomer, initialDateReport, endDateReport, withInbound, withOutbound, withSell, format);
        const response = await this.api.post('GetRepportOnDocument', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    private getJsonRead(idRepport : string, idName: string, idValue: string[], format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": idName,
                "Item2": idValue.join(",")
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadCustomerStock(idRepport: string, idCustomer: string[], warehouseNames: string[], bestBeforeDates: string[], inboundCodes: string[], goodNames: string[], format: string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "IdCustomer",
                "Item2": idCustomer.join(",")
            }, {
                "Item1": "WarehouseName",
                "Item2": warehouseNames.join(",")
            }, {
                "Item1": "BestBeforeDate",
                "Item2": bestBeforeDates.join(",")
            }, {
                "Item1": "InboundCode",
                "Item2": inboundCodes.join(",")
            }, {
                "Item1": "GoodName",
                "Item2": goodNames.join(",")
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadMaandaangifte(idRepport: string, dateIn: string, format: string): any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "DateIn",
                "Item2": dateIn
            }, {
                "Item1": "IdCompany",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadInboundOutboundSellReport(idRepport: string, idCustomer: string, initialDateReport: string, endDateReport: string, withInbound: boolean, withOutbound: boolean, withSell: boolean, format: string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "IdCustomer",
                "Item2": idCustomer
            }, {
                "Item1": "DateIni",
                "Item2": initialDateReport
            }, {
                "Item1": "DateEnd",
                "Item2": endDateReport
            }, {
                "Item1": "WithInbound",
                "Item2": withInbound ? 1 : 0
            }, {
                "Item1": "WithOutbound ",
                "Item2": withOutbound ? 1 : 0
            }, {
                "Item1": "WithSell ",
                "Item2": withSell ? 1 : 0
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStock(idRepport : string, idWarehouses: string[], dateIn: string[], bestBeforeDate: string[], locationName: string[], palletTypeName: string[], customerName: string[], inboundCode: string[], inboundCodeDestination: string[], goodName: string[], companySourceName: string[], format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "IdWarehouse",
                "Item2": idWarehouses.join(",")
            }, {
                "Item1": "DateIn",
                "Item2": dateIn.join(",")
            }, {
                "Item1": "BestBeforeDate",
                "Item2": bestBeforeDate.join(",")
            }, {
                "Item1": "LocationName",
                "Item2": locationName.join(",")
            }, {
                "Item1": "PalletTypeName",
                "Item2": palletTypeName.join(",")
            }, {
                "Item1": "CustomerName",
                "Item2": customerName.join(",")
            }, {
                "Item1": "InboundCode",
                "Item2": inboundCode.join(",")
            }, {
                "Item1": "InboundCodeDestination",
                "Item2": inboundCodeDestination.join(",")
            }, {
                "Item1": "GoodName",
                "Item2": goodName.join(",")
            }, {
                "Item1": "CompanySourceName",
                "Item2": companySourceName.join(",")
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStockGrouped(idRepport : string, idWarehouses: string[], dateIn: string[], bestBeforeDate: string[], locationName: string[], customerName: string[], inboundCode: string[], inboundCodeDestination: string[], goodName: string[], companySourceName: string[], format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "IdWarehouse",
                "Item2": idWarehouses.join(",")
            }, {
                "Item1": "DateIn",
                "Item2": dateIn.join(",")
            }, {
                "Item1": "BestBeforeDate",
                "Item2": bestBeforeDate.join(",")
            }, {
                "Item1": "LocationName",
                "Item2": locationName.join(",")
            }, {
                "Item1": "CustomerName",
                "Item2": customerName.join(",")
            }, {
                "Item1": "InboundCode",
                "Item2": inboundCode.join(",")
            }, {
                "Item1": "InboundCodeDestination",
                "Item2": inboundCodeDestination.join(",")
            }, {
                "Item1": "GoodName",
                "Item2": goodName.join(",")
            }, {
                "Item1": "CompanySourceName",
                "Item2": companySourceName.join(",")
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStockMovement(idRepport : string, idWarehouses: string[], idCompany: string, idsCustomers: string[], date: string, format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "DateStock",
                "Item2": date
            }, {
                "Item1": "IdWarehouse",
                "Item2": idWarehouses.join(",")
            }, {
                "Item1": "IdCompany",
                "Item2": idCompany
            }, {
                "Item1": "IdCustomer",
                "Item2": idsCustomers.map(id => `'${id}'`).join(",")
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStockMovementDates(idRepport : string, idWarehouses: string[], idCompany: string, dateStockIni: string, dateStockEnd : string, format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "DateStockIni",
                "Item2": dateStockIni
            }, {
                "Item1": "DateStockEnd",
                "Item2": dateStockEnd
            }, {
                "Item1": "IdWarehouse",
                "Item2": idWarehouses.join(",")
            }, {
                "Item1": "IdCompany",
                "Item2": idCompany
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStockMovementBillingDates(idRepport: string, idCustomer: string, dateStockIni: string, dateStockEnd : string, format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "DateStockIni",
                "Item2": dateStockIni
            }, {
                "Item1": "DateStockEnd",
                "Item2": dateStockEnd
            }, {
                "Item1": "IdCustomer",
                "Item2": idCustomer
            }, {
                "Item1": "IdCompany",
                "Item2": this.companyId
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadStockMovementCompanyAndDates(idRepport: string, idCompany: string, dateStockIni: string, dateStockEnd : string, format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parameters": [{
                "Item1": "DateStockIni",
                "Item2": dateStockIni
            }, {
                "Item1": "DateStockEnd",
                "Item2": dateStockEnd
            }, {
                "Item1": "IdCompanyDestination",
                "Item2": idCompany
            }, {
                "Item1": "IdCompanySource",
                "Item2": this.companyId
            }, {
                "Item1": "IdCompanyLogged",
                "Item2": this.companyId
            }],
            "format": format
        };
        return json;
    }

    private getJsonReadLabels(idRepport : string, idName: string, idStocks: string[], format : string) : any {
        const json = {
            "IdRepport": idRepport,
            "parametersPages": [],
            "format": format
        };

        return this.getConcatIds(idStocks, json);
    }

    private getConcatIds(idStocks: string[], json: any) : any {
        let ids : any[] = [];
        for (let id of idStocks) {
            let idStock : any = {
                "Item1": "Id",
                "Item2": id
            };
            ids.push(idStock);
            json.parametersPages.push(ids);
            ids = [];
        }
        // json.parametersPages.push(ids);
        return json;
    }
}
